import SeoHead from '../../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../../components/SubBanner';
import LatestNews from '../../../components/LatestNews';
import AllBlogs from '../../../components/AllBlogs';
import Header from '../../../components/MainHeader';

export default function AllNews({
    global,
    all_news,
    all_blogs,
    all_paginations,
    all_currentPage,
    currentPage
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Employers News & Insights | Gap Personnel`}
                // description={`Get the latest news, industry updates and updates from Driving Force today. Read about what Driving Force is doing and who we are helping.`}
                canonical_link={`/employers-news/page/${currentPage}/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`all_employers_news_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`News and insights`}
            />
            <LatestNews
                global={global}
                pathPrefix={`all_employers_news_page.latest_news`}
                customClass={`all-blogs-page mb-4`}
                heading={``}
                all_news={all_currentPage.items}
                buttonTitle={`Read`}
                removeIcons={true}
            />
            <AllBlogs
                global={global}
                pathPrefix={`all_employers_news_page.all_blogs`}
                all_blogs={all_currentPage.items}
                customClass={`all-blogs-page mb-5 pb-5`}
                buttonTitle={`Read`}
                heading={``}
                enableHeading={false}
                isAllBlogsPage={true}
                all_paginations={all_paginations}
                all_currentPage={all_currentPage}
                pageLink={`/employers-news/page/`}
                pagePrefix={`/employers-news/`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const employer_tag = "Employer";
    // const news = await Collection('news');
    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.tag?.en.includes(employer_tag)
            );
        })
    const all_news = news.orderBy('publish_date').getItems().slice(0, 3);
    const all_blogs = news.orderBy('publish_date').getItems();

    const all_paginations = news.getPages(9);
    const all_currentPage = news.getPageItems(params.page, 9);

    const currentPage = params.page;

    return {
        props: {
            global,
            all_news,
            all_blogs,
            all_paginations,
            all_currentPage,
            currentPage
        },
    }
}

export async function getStaticPaths() {
    const PagesPaths = (await Collection('news')).getPages(5);
    return {
        paths: PagesPaths,
        fallback: false
    }
}